module.exports = __webpack_public_path__ + "img/pos-tip.43b87d40.png";